export enum EGameConfigs {
  // Econ
  ECONOMY = 'economy',
  ITEMS = 'items',

  // Boosts
  BOOSTS = 'boosts',
  BOOSTS_TF = 'boosts-tf',

  // Bot parts
  BOT_PARTS = 'bot-parts',
  BOT_PARTS_TF = 'bot-parts-tf',
  BOT_PARTS_TF2 = 'bot-parts-tf2',

  // Action game skills
  CORE_SKILLS = 'core-skills',
  PART_SKILLS = 'part-skills',
  TF_SKILLS = 'tf-skills',

  // Match config bundle keys. Wire values retain their legacy map names until the REST contract is migrated.
  MATCH_CONFIGS_OR = 'maps-outpostRun',
  MATCH_CONFIGS_ZR = 'maps-domination',
  // Shared wire key: TF1 SP JSON under ALL_TERRAFORMING; TF MP match rows under COMBAT_GAME_MAPS.
  MATCH_CONFIGS_TF = 'maps-terraform',

  // Miscellaneous
  NICK_NAMES = 'nick-names',
  /**
   * Represents a group of configs unto itself, of all various types (images, spine atlases, audio, etc.)
   */
  ASSETS = 'assets',
  SWATCH_DATA = 'swatch-data',

  // Groups of others above
  ALL_COMBAT_GAME = 'all-combat-game',
  COMBAT_GAME_MAPS = 'combat-game-maps',
  ALL_TERRAFORMING = 'all-terraforming'
}
